import { render, staticRenderFns } from "./ActivityDataManager.vue?vue&type=template&id=da49b0fc&scoped=true"
import script from "./ActivityDataManager.vue?vue&type=script&lang=js"
export * from "./ActivityDataManager.vue?vue&type=script&lang=js"
import style0 from "./ActivityDataManager.vue?vue&type=style&index=0&id=da49b0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da49b0fc",
  null
  
)

export default component.exports